<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <!-- <nav class="footer-nav">
          <ul>
            <li>
              <a href="https://www.creative-tim.com" target="_blank" rel="noopener">Creative Tim</a>
            </li>
          </ul>
        </nav> -->
        <div class="credits ml-auto">
          <div class="copyright">
            &copy; Developed by
            <a href="http://ingenea.com.ar" target="_blank" rel="noopener">Ingenea SRL</a>.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'main-footer'
  }
</script>
<style>
</style>
